// extracted by mini-css-extract-plugin
export default {"icon":"notifications_icon__cv+ak","title":"notifications_title__WFPWK","date":"notifications_date__rn+QX"};